import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DiscountService } from '../../../services/DiscountService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import * as $ from 'jquery';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {
   
  constructor(private userService: UserService, public snackBar: MatSnackBar, private GL_MasterService: GL_MasterService) {

  }

  ngOnInit() {
    this.getBranchId();
  }

  is_allow_save: boolean = true;
  isBranchId: number = -1;
  getBranchId() {
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/user-add")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
    }
  }



  selectedFile: File = null;
  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
    console.log("selected file");
    console.log(this.selectedFile);
  }

  firstName: string = "";
  lastName: string = "";
  email: string = "";
  password: string = "";

  onSubmit(f: NgForm) {
    if (f.valid) {
      this.userService.register(this.email, this.password, this.firstName, this.lastName, "").subscribe(r => {


        if (r != undefined) {
          this.snackBar.open(" اضافه شد", null, { duration: 5000 });
        } else {
          this.snackBar.open("خطا در ثبت", null, { duration: 5000 });
        }
      });
      
    } else {
      this.snackBar.open("ورودی درست نیست", null, { duration: 5000 });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user/user-add/user-add.component.ts